<template>
  <v-btn class="primary px-2 py-2" :small="dense" @click.stop="openChatPanel">
    <v-icon class="pr-2">mdi-chat-outline</v-icon>
    {{ unreadIndicator }}
  </v-btn>
</template>

<script>
import { actions, getters } from '@/store/modules/collaboration/types';
import { state as authState } from '@/store/modules/auth/types';
import { mapState } from 'vuex';

export default {
  name: 'CollectionChat',
  props: {
    collection: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('auth', {
      currentUser: authState.USER,
    }),
    unreadIndicator() {
      const unread =
        this.$store.getters['collaboration/' + getters.UNREAD_FEED] || [];
      const userId = this.currentUser ? this.currentUser.id : null;
      const count = unread.filter(
        m => m.collection_id === this.collection.id && m.user_id !== userId
      ).length;
      return count > 0 ? count : '0';
    },
  },
  methods: {
    openChatPanel() {
      this.$store.dispatch(
        'collaboration/' + actions.OPEN_CHAT,
        this.collection
      );
    },
  },
};
</script>
